import { getToken } from "firebase/messaging";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { showToast } from "./components/custom/custom-toast";
import { Layout } from "./components/layout/layout";
import { PRIVILEGE_CODES } from "./constants/privileges";
import { ForgotPasswordPage } from "./features/auth/page/forgot-password-page";
import { LoginPage } from "./features/auth/page/login-page";
import NotFoundPage from "./features/not-found/not-found-page";
import { messaging, onMessageListener } from "./firebase";
import { useFetchData } from "./hooks/useFetch";
import { useFetcherDataBranchWorking } from "./hooks/useFetcherDataAPI";
import { ConfigsPublicModel } from "./models/response/configs-public";
import { dashboardRouter } from "./routers/app-router";
import { MODULE_ROUTE } from "./routers/module-router";
import { ProtectedRoutes } from "./routers/protected-router";
import { API_CONFIGS_ROUTER, API_DEVICE_TOKENS_ROUTER } from "./services/api-config";
import { isSuccess } from "./services/base-response";
import { useSocket } from "./state/socket-service";
import { IRootState } from "./store";
import { setBranches } from "./store/branchSlice";
import { setSidebarMenu, setSidebarMenuSub, toggleCloseNotification } from "./store/themeConfigSlice";
import CookieUtils from "./utils/cookie-utils";
import { getDeviceUUID } from "./utils/helpers";

const App: React.FC = () => {
  const dispatch = useDispatch();
  const { socket } = useSocket();
  const { connected, initializeSocket } = useSocket();
  const token = CookieUtils.getCurrentUser().access_token ?? "";
  const privilegeCodes = CookieUtils.getCookie<string[]>("privilege_codes") ?? [];
  const themeConfig = useSelector((state: IRootState) => state.themeConfig);
  // const status = useSelector((state: IRootState) => state.themeConfig.status);
  const { dataBranchWorking } = useFetcherDataBranchWorking();

  const { request: onDeviceTokens, baseResponse: resDeviceToken } = useFetchData.Post();
  const { request: fetchGetConfigsPublic, baseResponse: resConfigsPublic } = useFetchData.Get<ConfigsPublicModel>({
    apiPublic: true,
  });
  const [pushToken, setPushToken] = useState("");

  useEffect(() => {
    requestNotificationPermission(
      "BEiOaS-7uCCZLbsMD7YvznynDI4kvB6CmEGW-MnF4YoFwKBqI0g91TABpx2UCqOpS0gV2Brjob4ySne83Jcd5LM"
    );

    onMessageListener()
      .then((payload) => {
        if (payload) {
          // Check if payload exists
          dispatch(toggleCloseNotification(true));
          console.log("------------- nhận được thông báo ---------------:", payload);
        }
      })
      .catch((err) => console.log("failed: ", err));
    // Set up the message listener AFTER Firebase is initialized
    // fetchFirebaseConfig().then((config) => {
    //   console.log("🚀 ~ config:", config);
    //   if (!config.firebase_web_config) {
    //     console.error("Firebase config is missing");
    //     return;
    //   }
    // initializeFirebase()
    //   .then(() => {
    //     // if (config.firebase_vapid_key) {
    //     requestNotificationPermission(
    //       "<REDACTED_FIREBASE_VAPID_KEY>"
    //     );
    //     // }
    //     // Set up the message listener AFTER Firebase is initialized
    //     onMessageListener()
    //       .then((payload) => {
    //         if (payload) {
    //           // Check if payload exists
    //           dispatch(toggleCloseNotification(true));
    //           console.log(
    //             "------------- nhận được thông báo ---------------:",
    //             payload
    //           );
    //         }
    //       })
    //       .catch((err) => console.log("failed: ", err));
    //   })
    //   .catch((error) => {
    //     console.error("Firebase initialization failed:", error);
    //   });
    // });
  }, [dispatch, token]);

  const requestNotificationPermission = async (vapidKey?: string) => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        const token = await getToken(messaging, {
          vapidKey: vapidKey,
          serviceWorkerRegistration: undefined,
        });

        console.log("🚀 ~ requestNotificationPermission ~ token:", token);
        console.log(
          `🚀 ~ requestNotificationPermission ~ CookieUtils.getCookie("tokenNotification"):`,
          CookieUtils.getCookie("tokenNotification")
        );

        if (CookieUtils.getCookie("tokenNotification") !== token) {
          console.log("123213");
          handleOnDeviceTokens(token);
          setPushToken(token);
        }
        return token;
      } else {
        console.log("Notification permission denied.");
      }
    } catch (error) {
      console.error("Error getting FCM token:", error);
    }
  };

  useEffect(() => {
    dispatch(setBranches(dataBranchWorking));
  }, [dataBranchWorking]);

  useEffect(() => {
    if (!connected && token !== "") {
      initializeSocket(token);
    } else {
      console.log("have connect ", connected);
    }
  }, [connected, initializeSocket, token]);

  useEffect(() => {
    if (socket) {
      const branchIds = CookieUtils.getCurrentUser().branch_ids;
      if (branchIds && branchIds.length > 0) {
        socket.emit("join-branch", {
          branch_id: branchIds[0],
        });
      }
    }
  }, [token, socket]);

  const handleOnDeviceTokens = (tokenNotification: string) => {
    if (tokenNotification !== "") {
      onDeviceTokens({
        endPoint: API_DEVICE_TOKENS_ROUTER.API_REGISTER_DEVICE_TOKENS(),
        data: {
          device_id: getDeviceUUID(),
          token: tokenNotification,
          platform: 1,
        },
      });
    }
  };

  useEffect(() => {
    console.log("🚀 ~ App ~ resDeviceToken:", resDeviceToken);
    if (!resDeviceToken) return;
    if (isSuccess(resDeviceToken)) {
      // showToast({ message: "Đăng ký thành công", type: "success" });
      CookieUtils.setCookie("tokenNotification", JSON.stringify(pushToken));
    } else {
      // showToast({ message: resDeviceToken.message, type: "warning" });
    }
  }, [resDeviceToken]);

  useEffect(() => {
    if (themeConfig.sidebarMenu === "") return;
    dispatch(setSidebarMenu(themeConfig.sidebarMenu));

    if (themeConfig.sidebarMenuSub === "") return;
    dispatch(setSidebarMenuSub(themeConfig.sidebarMenuSub));
  }, [themeConfig]);

  useEffect(() => {
    fetchGetConfigsPublic({
      endPoint: API_CONFIGS_ROUTER.API_CONFIGS_PUBLIC(),
    });
  }, [token]);

  useEffect(() => {
    if (!resConfigsPublic) return;
    if (isSuccess(resConfigsPublic)) {
      CookieUtils.setCookie("domain", JSON.stringify(resConfigsPublic.data));
      if (!connected && token !== "") {
        initializeSocket(token);
      }
    } else {
      showToast({ message: resConfigsPublic.message, type: "warning" });
    }
  }, [resConfigsPublic]);

  return (
    <Router>
      <Routes>
        <Route
          index
          path={MODULE_ROUTE.LOGIN}
          element={token !== "" ? <Navigate replace to={MODULE_ROUTE.MANAGEMENT_SERVICE} /> : <LoginPage />}
        />
        <Route path={MODULE_ROUTE.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
        <Route element={<Layout />}>
          <Route element={<ProtectedRoutes />}>
            {dashboardRouter.map((route, index) => {
              const LazyComponent = route.component;
              switch (route.path) {
                case MODULE_ROUTE.BRANCH:
                  return (
                    privilegeCodes.find(
                      (item) => item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.BRANCH_MANAGEMENT
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );

                case MODULE_ROUTE.EMPLOYEE:
                  return (
                    privilegeCodes.find(
                      (item) =>
                        item === PRIVILEGE_CODES.OWNER_MANAGEMENT ||
                        item === PRIVILEGE_CODES.EMPLOYEE_MANAGEMENT_BASIC ||
                        item === PRIVILEGE_CODES.EMPLOYEE_DEPARTMENT_MANAGEMENT ||
                        item === PRIVILEGE_CODES.EMPLOYEE_PRIVILEGE_ASSIGNMENT ||
                        item === PRIVILEGE_CODES.SHIFT_SESSION_BASIC ||
                        item === PRIVILEGE_CODES.ATTENDANCES_BASIC ||
                        item === PRIVILEGE_CODES.SHIFT_BASIC
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.COMPUTERS:
                  return (
                    privilegeCodes.find(
                      (item) => item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.COMPUTER_BASIC
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.LIST_ACCOUNT_CUSTOMER:
                  return (
                    privilegeCodes.find(
                      (item) =>
                        item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.CUSTOMER_ACCOUNT_BASIC
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.ID_VERIFICATION:
                  return (
                    privilegeCodes.find(
                      (item) =>
                        item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.CUSTOMER_ID_VERIFICATION
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.RECHARGE_HISTORY:
                  return (
                    privilegeCodes.find(
                      (item) => item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.TOPUP_BASIC
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.BANK_TRANSFER_QUEUE:
                  return (
                    privilegeCodes.find(
                      (item) =>
                        item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.PAYMENT_TRANSFER_CONFIRM_MANAGEMENT
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.PROMOTION_BUY_HISTORY:
                  return (
                    privilegeCodes.find(
                      (item) =>
                        item === PRIVILEGE_CODES.OWNER_MANAGEMENT ||
                        item === PRIVILEGE_CODES.PROMOTION_COMBO_MANAGEMENT ||
                        item === PRIVILEGE_CODES.PROMOTION_TICKET_MANAGEMENT ||
                        item === PRIVILEGE_CODES.PROMOTION_RECHARGE_PACKAGE_MANAGEMENT ||
                        item === PRIVILEGE_CODES.PROMOTION_MEMBERSHIP_LEVEL_MANAGEMENT ||
                        item === PRIVILEGE_CODES.PROMOTION_CUSTOMER_DISCOUNT_MANAGEMENT ||
                        item === PRIVILEGE_CODES.PROMOTION_AREA_DISCOUNT_MANAGEMENT ||
                        item === PRIVILEGE_CODES.PROMOTION_CONFIRM
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.PROMOTION_CREDIT_PAGE:
                  return (
                    privilegeCodes.find(
                      (item) =>
                        item === PRIVILEGE_CODES.OWNER_MANAGEMENT ||
                        item === PRIVILEGE_CODES.PROMOTION_CREDIT_MANAGEMENT
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.BRANCH:
                  return (
                    privilegeCodes.find((item) => item === PRIVILEGE_CODES.BRANCH_MANAGEMENT) && (
                      <Route key={index} path={route.path} element={<LazyComponent />} />
                    )
                  );
                case MODULE_ROUTE.BRANCH:
                  return (
                    privilegeCodes.find((item) => item === PRIVILEGE_CODES.BRANCH_MANAGEMENT) && (
                      <Route key={index} path={route.path} element={<LazyComponent />} />
                    )
                  );
                case MODULE_ROUTE.EMPLOYEE:
                  return (
                    privilegeCodes.find(
                      (item) =>
                        item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.EMPLOYEE_MANAGEMENT_BASIC
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.LIST_DEPARTMENT:
                  return (
                    privilegeCodes.find(
                      (item) =>
                        item === PRIVILEGE_CODES.OWNER_MANAGEMENT ||
                        item === PRIVILEGE_CODES.EMPLOYEE_DEPARTMENT_MANAGEMENT
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.SHIFT_SESSION:
                  return (
                    privilegeCodes.find(
                      (item) =>
                        item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.SHIFT_SESSION_BASIC
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.TIMEKEEPING_USER_PAGE:
                  return (
                    privilegeCodes.find(
                      (item) => item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.ATTENDANCES_BASIC
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.SHIFT_PAGE:
                  return (
                    privilegeCodes.find(
                      (item) =>
                        item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.SHIFT_SESSION_BASIC
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.WORKSTATION_AREA:
                  return (
                    privilegeCodes.find(
                      (item) => item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.AREA_BASIC
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.MATERIAL_AND_PRODUCT:
                  return (
                    privilegeCodes.find(
                      (item) =>
                        item === PRIVILEGE_CODES.OWNER_MANAGEMENT ||
                        item === PRIVILEGE_CODES.PRODUCT_MATERIAL_MANAGEMENT
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.WAREHOUSING:
                  return (
                    privilegeCodes.find(
                      (item) => item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.WAREHOUSE_BASIC
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );

                case MODULE_ROUTE.INCOME_AND_EXPENDITURE:
                  return (
                    privilegeCodes.find(
                      (item) =>
                        item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.RECEIPT_PAYMENT_BASIC
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );

                case MODULE_ROUTE.CATEGORIES_RECEIPT_PAGE:
                  return (
                    privilegeCodes.find(
                      (item) =>
                        item === PRIVILEGE_CODES.OWNER_MANAGEMENT ||
                        item === PRIVILEGE_CODES.RECEIPT_PAYMENT_CATEGORY_MANAGEMENT
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.INVENTORY_WAREHOUSE:
                  return (
                    privilegeCodes.find(
                      (item) => item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.INVENTORY_BASIC
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.ORDER:
                  return (
                    privilegeCodes.find(
                      (item) =>
                        item === PRIVILEGE_CODES.OWNER_MANAGEMENT ||
                        item === PRIVILEGE_CODES.ORDER_MANAGEMENT ||
                        item === PRIVILEGE_CODES.ORDER_PENDING ||
                        item === PRIVILEGE_CODES.ORDER_CONFIRM ||
                        item === PRIVILEGE_CODES.ORDER_COMPLETED ||
                        item === PRIVILEGE_CODES.ORDER_DONE ||
                        item === PRIVILEGE_CODES.ORDER_CANCEL
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.BOOKING_MANAGEMENT:
                  return (
                    privilegeCodes.find(
                      (item) => item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.BOOKING_MANAGEMENT
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.RECHARGE_PACKAGE:
                  return (
                    privilegeCodes.find(
                      (item) =>
                        item === PRIVILEGE_CODES.OWNER_MANAGEMENT ||
                        item === PRIVILEGE_CODES.RECHARGE_PACKAGE_MANAGEMENT
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.MANAGEMENT_NEWFEED:
                  return (
                    privilegeCodes.find(
                      (item) => item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.NEWS_MANAGEMENT
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.MANAGEMENT_GAME:
                  return (
                    privilegeCodes.find(
                      (item) => item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.GAME_MANAGEMENT
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                case MODULE_ROUTE.SETTINGS:
                  return (
                    privilegeCodes.find(
                      (item) => item === PRIVILEGE_CODES.OWNER_MANAGEMENT || item === PRIVILEGE_CODES.SYSTEM_SETTINGS
                    ) && <Route key={index} path={route.path} element={<LazyComponent />} />
                  );
                default:
                  return <Route key={index} path={route.path} element={<LazyComponent />} />;
              }
            })}
          </Route>
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
};

export default App;
